export function play_sound(sound_id, data={}){
    document.dispatchEvent(new CustomEvent("board-sound", {
        detail: {
            "type": sound_id,
            ...data,
        },
    }));
}
